import React, { Component } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../common/Spinner';
import Card from '../../components/Card/Card';
import { StatsCard } from '../StatsCard/StatsCard';
import CountUp from 'react-countup';
import { getCurrentProfile, getStudents } from '../../actions/profileAction';

class HomePageTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ''
    };
  }

  componentDidMount(){
  }

  render() {
    const { loading } = this.props.student;
    let students = this.props.student.student;
    let studentItems;
    if (students === null || loading) {
      studentItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }

    else {
      if (students.length > 0) {
        const count = students.length;

        studentItems = students.map(student => (
          <tr key={student._id}>
            <td>{student.name}</td>
            <td>{student.email}</td>
          </tr>
        ));
      }
      else {
        studentItems = (
          <tr>
            <td>Još uvek nema delegata</td>
          </tr>
        );
      }
    }

    return (
      <div className="content">
        <Row className='justify-content-center'>
          <Col lg={3} sm={3}>
            <StatsCard
              bigIcon={<i className="pe-7s-date" />}
              statsText="Dana"
              statsValue={
              <CountUp
                className="account-balance"
                start={0}
                end={4}
                duration={3}
                useGrouping={true}
              />}
            />
          </Col>
          <Col lg={3} sm={3}>
            <StatsCard
              bigIcon={<i className="pe-7s-micro" />}
              statsText="Predavanja"
              statsValue={
              <CountUp
                className="account-balance"
                start={0}
                end={9}
                duration={4}
                useGrouping={true}
              />}
            />
          </Col>
          <Col lg={3} sm={3}>
            <StatsCard
              bigIcon={<i className="pe-7s-id" />}
              statsText="Delegata"
              statsValue={
                <CountUp
                  className="account-balance"
                  start={0}
                  end={389}
                  duration={5}
                  useGrouping={true}
                />}
            />
          </Col>
        </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Delegati"
               
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover >
                    <thead>
                      <tr>
                        <th>Ime i prezime</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>{studentItems}</tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

HomePageTable.propTypes = {
  getStudents: PropTypes.func.isRequired,
  student: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  student: state.student,
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { getStudents, getCurrentProfile }
)(HomePageTable);
